// React
import React from 'react';
import { Row, Col, Input } from 'reactstrap';

// Containers
import { DataTable } from '../../containers/componentsInjection';

// Helpers
import { getLoggedinUser } from '../../../../helpers/api_helper';

export const PaymentLinksTab = ({ paymentLinks, setPaymentLinks }) => {
  let offices = getLoggedinUser().data.offices;

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Escritório</span>,
      sortable: true,
      width: '30%',
      selector: (cell) => {
        return <u>{cell.name}</u>;
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Link de Pagamento</span>,
      sortable: false,
      selector: (cell) => {
        const handleChange = (e) => {
          const { id, value } = e.target;
          setPaymentLinks((prevState) => ({
            ...prevState,
            [id]: value,
          }));
        };

        return (
          <Input
            id={`${cell.office_id}`}
            name={`${cell.office_id}`}
            type="text"
            placeholder="Link de pagamento"
            className="h-35px form-control"
            style={{
              width: '300px',
            }}
            onChange={handleChange}
            value={paymentLinks[`${cell.office_id}`]}
          />
        );
      },
    },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col
          xs={12}
          style={{
            marginTop: -20,
          }}
        >
          <DataTable
            persistTableHead
            canSearch={false}
            columns={columns}
            isSearchRemote={false}
            title="Links de Pagamento"
            data={offices || []}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};
